import { render, staticRenderFns } from "./SLoader.vue?vue&type=template&id=7a588c07&scoped=true&"
import script from "./SLoader.vue?vue&type=script&lang=ts&"
export * from "./SLoader.vue?vue&type=script&lang=ts&"
import style0 from "./SLoader.vue?vue&type=style&index=0&id=7a588c07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a588c07",
  null
  
)

export default component.exports